module.exports = __webpack_public_path__ + "static/power2-1@2x-aaac9aa9dce640b36dc0d45ff6991559.png";